import { LandingIcon } from './icons'
import styles from './CampaignScene.module.css'
export function CampaignScene() {
  return (
    <div
      className={styles.scene}
      role="img"
      aria-label="Bilhetes tridimensionais Sortee representando a criação de uma nova campanha"
    >
      <div className={styles.orbit} />
      <div className={styles.orbitTwo} />
      <span className={styles.sceneLabel}>FEITO PARA CONECTAR.</span>
      <div className={styles.sphere} />
      <div className={styles.ticketStack} aria-hidden="true">
        <div className={styles.backTicket}>
          <span>SUA IDEIA TEM POTENCIAL.</span>
          <strong>
            Vamos
            <br />
            mais longe.
          </strong>
          <LandingIcon name="star" className={styles.backStar} />
        </div>
        <div className={styles.ticket}>
          <div className={styles.ticketTop}>
            <span className={styles.ticketBrand}>
              <img src="/logo/sortee.png" alt="" width="2089" height="753" />
            </span>
            <span className={styles.ticketSmall}>
              BOAS IDEIAS
              <br />
              GANHAM VIDA.
            </span>
          </div>
          <div className={styles.ticketTitle}>
            Um número.
            <br />
            Infinitas
            <br />
            <em>possibilidades.</em>
          </div>
          <div className={styles.ticketBottom}>
            <span>
              SUA PRÓXIMA CAMPANHA<strong>Nº 000.001</strong>
            </span>
            <span className={styles.barcode} />
          </div>
          <div className={styles.ticketStub}>
            <span>O SEU PRÓXIMO GRANDE MOMENTO</span>
            <LandingIcon name="star" className={styles.stubStar} />
          </div>
        </div>
      </div>
      <div className={styles.confirmation} aria-hidden="true">
        <span className={styles.check}>
          <LandingIcon name="check" width="17" height="17" />
        </span>
        <span>
          Sua ideia ganhou forma.<strong>Agora, é hora de compartilhar.</strong>
        </span>
        <span className={styles.notificationDot} />
      </div>
      <span className={styles.sceneCaption}>SORTEIOS. CONEXÕES. NOVAS HISTÓRIAS.</span>
      <LandingIcon name="star" className={styles.smallStar} />
    </div>
  )
}
